var _clipPath;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayer2Night(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1440px",
    height: "175px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer-2",
    serifId: "layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.001,40.405L0,173.328L1440,174.443L1440,42.125L0.001,40.405Z",
    style: {
      fill: "url(#_Linear1)"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.001,40.405L0,173.328L1440,174.443L1440,42.125L0.001,40.405Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1420.63,75.684C1420.99,75.718 1421.26,76.03 1421.25,76.392C1421.23,76.755 1420.93,77.04 1420.57,77.04C1368.47,77.035 1201.47,77.017 1099.98,77.007C1099.3,77.002 1098.75,76.458 1098.73,75.78C1098.72,75.101 1099.24,74.533 1099.92,74.497C1099.92,74.496 1099.93,74.496 1099.93,74.496C1114.06,73.738 1127.88,72.291 1142.51,72.202C1157.84,72.108 1171.9,74.069 1186.8,74.593C1222.04,75.832 1254.95,71.299 1287.04,73.049C1322.28,74.971 1350.39,72.749 1374.14,72.989C1386.46,73.114 1406.57,74.556 1420.63,75.684Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.145,57.35C810.641,57.388 811.019,57.812 811,58.309C810.981,58.807 810.572,59.201 810.073,59.201C751.868,59.195 593.513,59.179 495.834,59.169C495.155,59.164 494.603,58.621 494.587,57.942C494.572,57.263 495.098,56.695 495.776,56.659C495.778,56.658 495.78,56.658 495.782,56.658C509.915,55.901 523.729,54.453 538.362,54.364C553.697,54.27 567.755,56.231 582.655,56.755C617.891,57.994 650.8,53.461 682.898,55.211C718.138,57.134 746.242,54.911 769.999,55.151C780.559,55.258 796.849,56.334 810.145,57.35Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1508.41,60.992C1509.5,61.046 1510.36,61.964 1510.33,63.062C1510.31,64.161 1509.41,65.037 1508.31,65.037C1435.32,65.028 1314.19,65.015 1233.98,65.007C1233.3,65.002 1232.75,64.458 1232.73,63.78C1232.72,63.101 1233.24,62.533 1233.92,62.497C1233.92,62.496 1233.93,62.496 1233.93,62.496C1248.06,61.738 1261.88,60.291 1276.51,60.202C1291.84,60.108 1305.9,62.069 1320.8,62.593C1356.04,63.832 1388.95,59.299 1421.04,61.049C1456.28,62.971 1484.39,60.749 1508.14,60.989C1508.23,60.99 1508.32,60.991 1508.41,60.992Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026.26,68.154C1027.36,68.208 1028.21,69.127 1028.19,70.225C1028.16,71.323 1027.26,72.199 1026.16,72.199C953.176,72.19 832.047,72.177 751.834,72.169C751.155,72.164 750.603,71.621 750.587,70.942C750.572,70.263 751.098,69.695 751.776,69.659C751.778,69.658 751.78,69.658 751.782,69.658C765.915,68.901 779.729,67.453 794.362,67.364C809.697,67.27 823.755,69.231 838.655,69.755C873.891,70.994 906.8,66.461 938.898,68.211C974.138,70.134 1002.24,67.911 1026,68.151C1026.09,68.152 1026.17,68.153 1026.26,68.154Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "boat"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M883.384,4.8C883.384,4.8 905.526,45.623 911.473,56.589C911.779,57.152 911.765,57.834 911.438,58.385C911.11,58.936 910.516,59.273 909.876,59.273C903.749,59.273 890.124,59.273 885.202,59.273C884.72,59.273 884.258,59.081 883.917,58.741C883.576,58.4 883.384,57.937 883.384,57.455C883.384,47.993 883.384,4.8 883.384,4.8Z",
    style: {
      fill: "#f72565"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.769,20.495L884.769,59.273L867.461,59.273C866.825,59.273 866.235,58.94 865.906,58.396C865.577,57.852 865.556,57.175 865.851,56.612C870.438,47.856 884.769,20.495 884.769,20.495Z",
    style: {
      fill: "#fb5286"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.769,2.491C884.769,1.726 884.15,1.107 883.385,1.107C883.385,1.107 883.384,1.107 883.384,1.107C882.619,1.107 882,1.726 882,2.491C882,11.282 882,59.254 882,68.045C882,68.809 882.619,69.429 883.384,69.429C883.384,69.429 883.385,69.429 883.385,69.429C884.15,69.429 884.769,68.809 884.769,68.045C884.769,59.254 884.769,11.282 884.769,2.491Z",
    style: {
      fill: "#661434"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.498,67.151C864.878,66.678 864.629,65.863 864.879,65.125C865.129,64.386 865.821,63.889 866.601,63.889C877.467,63.889 901.678,63.889 909.51,63.889C910.091,63.889 910.637,64.167 910.979,64.637C911.321,65.107 911.418,65.712 911.24,66.265C910.749,67.787 910.131,69.703 909.732,70.939C909.49,71.69 908.791,72.199 908.003,72.199C901.944,72.199 876.967,72.199 872.722,72.199C872.323,72.199 871.936,72.068 871.619,71.826C870.541,71.002 867.864,68.959 865.498,67.151Z",
    style: {
      fill: "#661434"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.384,2.319C886.346,0.032 890.56,-0.583 894.109,0.561C896.925,1.468 898.785,3.486 902.292,4.029C904.03,4.298 906.18,4.119 907.369,3.977C907.51,3.959 907.647,4.03 907.714,4.154C907.78,4.279 907.764,4.432 907.671,4.539C906.35,5.9 902.895,8.823 897.586,8.675C890.703,8.483 888.893,2.969 883.57,4.806",
    style: {
      fill: "#661434"
    }
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.93108e-14,-315.369,4.03222,2.46903e-16,880.098,280.443)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00567c",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#0f4d6b",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#2e3a47",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4d2724",
      stopOpacity: 1
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer2Night);
export default __webpack_public_path__ + "static/media/layer2-night.0f94389a63978f5ac6685b8ac4cd1ba8.svg";
export { ForwardRef as ReactComponent };